import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=7127da67&scoped=true"
import script from "./inquiry.vue?vue&type=script&lang=js"
export * from "./inquiry.vue?vue&type=script&lang=js"
import style0 from "./inquiry.vue?vue&type=style&index=0&id=7127da67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127da67",
  null
  
)

export default component.exports